import * as React from 'react';
import { FormSectionBase, FormSectionBaseState } from '../Types/FormSectionBase';
import { CheckBoxGroup, CheckBoxGroupState } from 'sos-common/js/components/FormControls/CheckBoxGroup';
import { CheckBox } from 'sos-common/js/components/FormControls/CheckBox';
import { FieldName, ApplicationType } from '../Types/Intyg.enums';
import { FormField } from 'sos-common/js/commonTypes/formField.types';
import { RefSetter } from '../Utils/RefSetter';
import _ from 'lodash';
import { IKeyValue } from '../Types/ansokan.types';

export interface ISprakForIntygetProps {}
export interface ISprakForIntygetState extends FormSectionBaseState {}

enum LocalFieldName {
  SprakForIntygetCheckboxGroup = 'SprakForIntygetCheckboxGroup',
}

export default class SprakForIntyget extends FormSectionBase<ISprakForIntygetProps, ISprakForIntygetState> {
  constructor(props: ISprakForIntygetProps) {
    super(props);

    this.fieldRefs.set(LocalFieldName.SprakForIntygetCheckboxGroup, React.createRef<CheckBoxGroup>());

    this.state = {
      errors: this.emptyErrorsMap,
    };
  }

  // The reason for calling this.context.onChangeCheckboxGroupValue here is to initially update
  // the context model with either true or false values. If I don't do this the model will hold
  // null values instead (initially). I need to differentiate between null and false values in
  // Adressuppgifter / ManuellaAdressuppgifter / AntalIntygPerSprak - components.
  componentDidMount = () => {
    this.setInitialErrorsMap();
    let field = this.fieldRefs.get(LocalFieldName.SprakForIntygetCheckboxGroup).current.state as CheckBoxGroupState;
    this.context.onChangeCheckboxGroupValue(field);
  };

  onChangeCheckboxGroup = (checkboxGroup: CheckBoxGroupState) => {
    const { model, updateModelUsingKeyValue, updateModelAsBatch } = this.context;
    const adresserClone = _.cloneDeep(model.adresser);
    const batchArray: IKeyValue[] = [];

    checkboxGroup.childrenFieldNames.forEach((fieldName) => {
      const isChecked = checkboxGroup.value.find((x) => x === fieldName) !== undefined;
      if (!isChecked) {
        if (model.adresser) {
          adresserClone.forEach((adress) => {
            switch (fieldName) {
              case FieldName.PdfEngelska:
                adress.antalEngelska = 0;
                break;
              case FieldName.PdfSvenska:
                adress.antalSvenska = 0;
                break;
            }
          });
        }
        switch (fieldName) {
          case FieldName.PdfEngelska:
            batchArray.push({ key: FieldName.AntalEngelskaTillFolkbokforing, value: 0 });
            break;
          case FieldName.PdfSvenska:
            batchArray.push({ key: FieldName.AntalSvenskaTillFolkbokforing, value: 0 });
            break;
        }
      }
    });
    batchArray.push({ key: 'adresser', value: adresserClone });
    updateModelAsBatch(batchArray);
    this.onChangeField(checkboxGroup, this.context.onChangeCheckboxGroupValue);
  };

  hiddenLangInput = () => {
    const { model, Translate } = this.context;
    const availableLangs = [];
    if (model.pdfSvenska) availableLangs.push(Translate('svenska'));
    if (model.pdfEngelska) availableLangs.push(Translate('engelska'));
    if (availableLangs.length === 0) return null;
    return availableLangs.join(', ');
  };

  public render() {
    const { Translate, applicationType } = this.context;
    const hiddenLangVal = this.hiddenLangInput();
    return (
      <RefSetter fieldRefs={this.fieldRefs}>
        <section className="m-b-4">
          <h3 className="like-a-label">{Translate('valjsprak') + ' (obligatoriskt)'}</h3>
          <CheckBoxGroup
            fieldName={LocalFieldName.SprakForIntygetCheckboxGroup}
            onChange={this.onChangeCheckboxGroup}
            value={this.getCheckboxGroupValue([FieldName.PdfSvenska, FieldName.PdfEngelska])}
            isRequired={true}
            useChildrensFieldNames={true}
            errorMessage={this.getErrorMessage(LocalFieldName.SprakForIntygetCheckboxGroup)}>
            <CheckBox
              stringValue={FieldName.PdfSvenska}
              fieldName={FieldName.PdfSvenska}
              label={Translate('svenska')}
            />
            <CheckBox
              stringValue={FieldName.PdfEngelska}
              fieldName={FieldName.PdfEngelska}
              label={Translate('engelska')}
            />
          </CheckBoxGroup>
          {applicationType === ApplicationType.Webform && hiddenLangVal && (
            <input type="hidden" name="lang_checkbox" value={hiddenLangVal} />
          )}
        </section>
      </RefSetter>
    );
  }
}
